import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_deviceRelay = _resolveComponent("deviceRelay")
  const _component_external_relay = _resolveComponent("external-relay")
  const _component_el_form = _resolveComponent("el-form")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_dialog_shell, {
      title: _ctx.$wordList.TabelPersonDeviceTitleMod,
      onClose: _ctx.close,
      width: "780px",
      onSubmit: _ctx.checkValid
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-position": _ctx.$formLabelPosition,
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "deviceEditFormRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.ChangeWordList.PMSetAccessBuildOrDepartment
            }, {
              default: _withCtx(() => [
                (_ctx.projectType==='community')
                  ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.formData.UnitName || "--"), 1))
                  : (_ctx.projectType==='office')
                    ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.formData.DepartmentName || "--"), 1))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.projectType==='community')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _ctx.$wordList.RDeviceSearchLabelRoomName
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", null, _toDisplayString(_ctx.formData.RoomName || "--"), 1)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelPersonDeviceInHtmlLocation,
              prop: "Location"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Location,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Location = $event)),
                  "auto-complete": "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.showMonitorControl)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: _ctx.$wordList.DeviceMonitorControlTip,
                  prop: "AllowEndUserMonitor"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.formData.AllowEndUserMonitor,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.AllowEndUserMonitor = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: "1" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$wordList.CallSetYes), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: "0" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$wordList.TextNo), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.formData.Type === '0' && _ctx.formData.Grade === '2')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: _ctx.$wordList.ProperAllTextContactsSetting
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      modelValue: _ctx.formData.StairShow,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.StairShow = $event)),
                      label: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.ChangeWordList.DeviceContactFirstSetting), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _hoisted_3,
                    _createVNode(_component_el_radio, {
                      modelValue: _ctx.formData.StairShow,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.StairShow = $event)),
                      label: "3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.ChangeWordList.DeviceContactSecondSetting), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _hoisted_4,
                    _createVNode(_component_el_radio, {
                      modelValue: _ctx.formData.StairShow,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.StairShow = $event)),
                      label: "2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.ChangeWordList.DeviceContactThirdSetting), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_deviceRelay, {
              ref: "deviceRelayRef",
              relay: _ctx.formData.Relay,
              "security-relay": _ctx.formData.SecurityRelay,
              "relay-init-format": _ctx.formData.relayInitFormat,
              "security-relay-init-format": _ctx.formData.securityRelayInitFormat,
              "limit-one-enable": _ctx.formData.Type==='2'?false:true,
              "show-relay-add-btn": _ctx.formData.Type==='2'?false:true,
              "show-security-relay-add-btn": (_ctx.formData.Type==='2'||!_ctx.isNew)?false:true,
              "access-group-for-relay-schedule": _ctx.accessGroupForRelaySchedule,
              onAddRealyCallBack: _cache[6] || (_cache[6] = (formData)=>{_ctx.generateAccessGroupList(formData.relay.length)})
            }, null, 8, ["relay", "security-relay", "relay-init-format", "security-relay-init-format", "limit-one-enable", "show-relay-add-btn", "show-security-relay-add-btn", "access-group-for-relay-schedule"]), [
              [_vShow, ['0', '1', '2', '50'].includes(_ctx.formData.Type)]
            ]),
            _createVNode(_component_external_relay, {
              ref: "externalDeviceRelayRef",
              "project-type": _ctx.projectType,
              deviceType: (_ctx.formData.Type as string),
              originExternalRelay: _ctx.formData.ExtraRelay
            }, null, 8, ["project-type", "deviceType", "originExternalRelay"])
          ]),
          _: 1
        }, 8, ["label-position", "model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "onClose", "onSubmit"])
  ]))
}